import React from "react";
import { NavLink } from "react-router-dom";
import url from "../../../url";
import useTranslate from "../../../hooks/useTranslate";
import { makeLangUrl } from "../../../helpers/makeLangUrl";
import "./styles.sass";

type CoinFestSidebarProps = {
  isSidebarOpen: boolean;
};

const CoinFestSidebar = ({ isSidebarOpen }: CoinFestSidebarProps) => {
  const point =
    "https://diswdgcu9cfva.cloudfront.net/landings/casino/coinfestival/bigpoint.webp";
  const point2 =
    "https://diswdgcu9cfva.cloudfront.net/landings/casino/coinfestival/pointsmall.webp";
  const imgSrc = isSidebarOpen ? point : point2;
  const t = useTranslate();

  return (
    <div className={`coinFestSidebar ${isSidebarOpen ? "open" : "closed"}`}>
      <NavLink to={makeLangUrl(url.routes.coinFest.index())}>
        <img className="coinFestSidebar__img" src={imgSrc} alt=" " />
        {isSidebarOpen && (
          <div className="coinFestSidebar__text">{t("coin.banner.title")}</div>
        )}
      </NavLink>
    </div>
  );
};

export default CoinFestSidebar;
